import React from "react";
function HeaderHome() {
  return (
    <div>
      <header className="header-home">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h1 className="text-center mt-4 wow animate__animated animate__fadeInDown">
                سوفت تريد
              </h1>
              <p className="text-center wow animate__animated animate__fadeInUp">
                طعم مختلف… وجودة تثق فيها
              </p>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
}

export default HeaderHome;
